import { IconMessages } from '@tabler/icons-react'

import { ACTION_BUTTON_STYLE } from '@/pages/Patient/components/patientChartActionStyle'

type MessagesActionButtonProps = {
  isActive: boolean
  onToggle: () => void
}

/**
 * Messages toggle for the patient header's action group — the trigger for
 * `<MessagesCollapsableContainer>`'s right-edge drawer. Reuses
 * `ACTION_BUTTON_STYLE` so its metrics match the neighbouring buttons.
 */
export const MessagesActionButton = ({ isActive, onToggle }: MessagesActionButtonProps) => (
  <button
    type="button"
    aria-label="Toggle messages"
    aria-pressed={isActive}
    onClick={onToggle}
    style={{
      ...ACTION_BUTTON_STYLE,
      // Icon-only: square footprint instead of the label buttons' side padding.
      width: 36,
      padding: 0,
      background: isActive ? '#3b82f6' : '#fff',
      borderColor: '#3b82f6',
      color: isActive ? '#fff' : '#3b82f6',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = isActive ? '#2f6fd0' : '#eff6ff'
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = isActive ? '#3b82f6' : '#fff'
    }}
  >
    <IconMessages size={18} />
  </button>
)
